<div class="filter-administration">

    <sc-master-detail [selection]="[selectedFilter]" [data]="previewFilters" 
        (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);" [newStyle]="true"
        (deleteEntry)="onDeleteEntry($event);">

        <sc-flex [fitHeight]="true" [stretchContent]="true">
            <sc-flex-fitting-content>
                <app-filter-editor [setfilterAdministrationContext]="filterAdministrationContext"
                    (saveDetails)="onSaveDetails($event)" (cancelDetails)="onCancelDetails($event)"
                    class="filter-editor">
                </app-filter-editor>
            </sc-flex-fitting-content>
            <div class="contitions-list">
                <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
                    <app-details-editor-wrapper [setfilterAdministrationContext]="filterAdministrationContext">
                    </app-details-editor-wrapper>
                    <sc-flex-fitting-content [vertical]="true">
                        <app-condition-types [setfilterAdministrationContext]="filterAdministrationContext"
                            class="filter-types"></app-condition-types>
                    </sc-flex-fitting-content>
                </sc-flex>
            </div>
        </sc-flex>
    </sc-master-detail>
</div>